import React from 'react';
import { motion } from 'framer-motion';

const WelcomeVideo = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="w-4/5 mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-10"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Stop Overpaying For Your Business Phone System
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Learn how switching to 3CX can dramatically reduce your communications costs
          </p>
        </motion.div>

        <motion.div
          className="rounded-2xl overflow-hidden shadow-xl"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div style={{ position: 'relative', aspectRatio: '16/9' }}>
            <iframe
              loading="lazy"
              title="Gumlet video player"
              src="https://play.gumlet.io/embed/6872abdf14683753e667f89e?background=false&autoplay=false&loop=false&disableControls=false"
              style={{
                border: 'none',
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%'
              }}
              allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;fullscreen;"
            ></iframe>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WelcomeVideo;